export default __webpack_public_path__ + "static/media/3.2900dd42.jpg";